/**
 * header.jsx
 *
 * @Author: jruif
 * @Date: 2017/7/17 下午5:14
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col, Icon, Tooltip } from 'neatui';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import logo from '../../assets/images/logo.png';
import Star from './star';
import action from '../../reduxModules/action';
import OpenMsg from './openMsg';
import './header.scss';

const authNameUrl = 'http://mp.163.com/college.html#/guidence/account/authentication';

class Header extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    user: PropTypes.object,
    updateState: PropTypes.func,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      openMsg: false,
    };
    const { router } = props;
    this.searchObj = {};
    if (router.location.search) {
      router.location.search.match(/(\w+=[^&=?]+)(?=&|)/g).forEach(item => {
        const rs = item.split('=');
        this.searchObj[rs[0]] = rs[1];
      });
    }
  }

  renderUserInfo = (location, href) => {
    const { user, message, router, updateState, updateMsg, msgProjectLink } = this.props;
    let res = null;
    const { type } = this.searchObj;
    if (user.wemediaId) {
      res = (
        <div className="user-info">
          <div className="user-info-name">
            <a href={`/subscribe_v3/index.html#/account-settings${router.location.search}`} target="_self">
              {user.tname}
            </a>
          </div>
          <div className="user-info-func">
            {/* <span>
              {user.star !== -2 && <Star user={user} updateState={updateState} />}
              {user.star >= 0 && !!user.newProminent && <span className="tag">特色</span>}
              {user.videoTag ? <span className="tag">新农人</span> : null}
              {user.star === -2 && <span className="tag">新手期</span>}
              {user.mcnFlag ? <span className="tag">MCN</span> : null}
              {user.wemediaId && (
                <OpenMsg
                  user={user}
                  updateMsg={updateMsg}
                  updateState={updateState}
                  message={message}
                  msgProjectLink={msgProjectLink}
                  msgRoute={`/message${router.location.search}`}
                />
              )}
            </span> */}
            {user.wemediaId && (
                <OpenMsg
                  user={user}
                  updateMsg={updateMsg}
                  updateState={updateState}
                  message={message}
                  msgProjectLink={msgProjectLink}
                  msgRoute={`/message${router.location.search}`}
                />
              )}
            <a
              href={`//reg.163.com/Logout.jsp?&url=${location.protocol}//${
                location.host
              }/login.html${encodeURIComponent(`?url=${href}`)}`}
              target="_self">
              退出
            </a>
          </div>
        </div>
      );
    } else if (user.loginUser) {
      // 入驻页重构后，需获取邮箱信息显示
      res = (
        <div className="header-login">
          {user.loginUser}
          <a
            href={`//reg.163.com/Logout.jsp?&url=${location.protocol}//${
              location.host
            }/login.html${encodeURIComponent(`?url=${href}`)}`}
            target="_self">
            退出
          </a>
        </div>
      );
    } else {
      // 入驻页 登录邮箱页面顶部导航只显示退出按钮
      res =
        type && type === 'loginEmail' ? (
          <div className="header-login">
            {user.loginUser}
            <a
              href={`//reg.163.com/Logout.jsp?&url=${location.protocol}//${
                location.host
              }/login.html${encodeURIComponent(`?url=${href}`)}`}
              target="_self">
              退出
            </a>
          </div>
        ) : (
          <div className="header-login">
            <a href={`/login.html?url=${encodeURIComponent(href)}`} target="_self">
              登录
            </a>
            <a
              href="/index.html#/to_reg?type=loginEmail"
              className="header-logon-btn"
              target="_self">
              注册
            </a>
          </div>
        );
    }
    return res;
  };

  render() {
    const { className, user, router } = this.props;
    // 退出系统不需要具体路由信息
    const { location } = window;
    const href = location.href.replace(/#.+$/, '');
    return (
      <div className={className}>
        <Row className="header-content" justify="between" align="middle">
          <Col>
            <Link to={`/index${router.location.search}`}>
              <img src={logo} alt="有态度 不独行" title="网易号媒体开放平台" />
            </Link>
          </Col>
          {user.faceDetectFlag && (
            <Col size={14} className="verify-warn">
              <p>
                <Icon type="warn-1" className="icon" />
                未完成实名认证 请使用
                <Tooltip
                  content={<span className="red-font">该网易号的注册帐号</span>}
                  autoAdjustPosition
                  position="bottom">
                  帐号：{user.loginUser}
                </Tooltip>
                登录
                <Tooltip
                  content={<span className="red-font">网易新闻客户端</span>}
                  autoAdjustPosition
                  position="bottom">
                  <img
                    src="http://static.ws.126.net/f2e/include/common_nav/images/topapp.jpg"
                    alt="下载网易新闻客户端"
                    title="使用手机扫一扫，下载网易新闻客户端"
                  />
                </Tooltip>
                ，点击「我的」-「实名认证」操作
                <a
                  className="auth-name"
                  href={authNameUrl}
                  rel="noopener noreferrer"
                  target="_blank">
                  教程
                </a>
              </p>
            </Col>
          )}
          <Col>
            <div className="user">
              <div className="user-photo">
                {user.icon && (
                  <a href={`/subscribe_v3/index.html#/account-settings${router.location.search}`} target="_self">
                    <img src={user.icon} title="进入用户设置" alt="" />
                  </a>
                )}
              </div>
              {this.renderUserInfo(location, href)}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect(
  state => ({
    user: state.common.user,
    message: state.message.unRead,
    router: state.router,
  }),
  dispatch =>
    bindActionCreators(
      {
        updateMsg: action.updateMsg,
      },
      dispatch,
    ),
)(Header);
